export function filterIncorrectDate(date: string) {
  if (date.length < 10) return date;

  const datesArr = date.split('.');

  if (datesArr.length !== 3) return date;

  let day = datesArr[0];
  let month = datesArr[1];
  let year = datesArr[2];

  const yearNum = Number(year);
  const curYear = new Date().getFullYear();

  if (Number(day) > 31) day = '01';
  if (Number(month) > 12) month = '01';
  if (yearNum > curYear + 50 || (yearNum > 1000 && yearNum < curYear - 100))
    year = `${new Date().getFullYear()}`;

  return `${day}.${month}.${year}`;
}
